import React from 'react'
import ModalFormUI from '../../../widgets/form/ModalFormUI'
import InputTextSF from '../../../widgets/form/InputTextSF'
import InputSelectUI from '../../../widgets/form/InputSelectUI'

const MappingCreateModalUI = ({ context, successMsg, errorList, setErrorList,
  // sourceValue
  sourceValue, onSourceValueChange, sourceValueError, setSourceValueError,
  // superuser role
  mappedValue, mappedValueList, mappingGroup, onMappedValueChange, mappedValueError,
  //
  ignoreSpaces, onIgnoreSpacesChange, booleanList,
  // modes
  createMode, submitted,
  // event handlers
  onSubmit, onCancelClick,
}) => {
  const isPaymentCategory =
    mappingGroup === 'bank_analyzer_payment_category';
  return (
    <ModalFormUI
      context={context}
      titleLabel={
        isPaymentCategory
          ? 'Add Payment Category'
          : 'Add Keyword'
      }
      buttonLabel='Add'
      cancelLabel='Cancel'
      isOpen={createMode}
      onRequestClose={onCancelClick}
      successMsg={successMsg}
      errorList={errorList}
      setErrorList={setErrorList}
      onSubmit={onSubmit}
      busy={submitted}
    >
      <InputTextSF type='text' name='sourceValue'
        label={
          isPaymentCategory
            ? 'Payment Category'
            : 'Keyword'
        }
        maxLength={100}
        value={sourceValue} onChange={onSourceValueChange}
        error={sourceValueError} setError={setSourceValueError}
        autoFocus={true}
      />
      <InputSelectUI name='mappedValue' label='Category' value={mappedValue}
        optionList={mappedValueList}
        onChange={onMappedValueChange} error={mappedValueError}
      />
      {
        !isPaymentCategory &&
        <InputSelectUI
          name='ignoreSpaces'
          label='Ignore spaces'
          value={ignoreSpaces}
          optionList={booleanList}
          onChange={onIgnoreSpacesChange}
        />
      }
    </ModalFormUI>
  )
}
export default MappingCreateModalUI
